import { parse, format, subMinutes, getMinutes } from 'date-fns';
import { FormikValues } from 'formik';
import { fiftyNineMinutes } from '@constants/timeRange';

export const convertTimesBlackout = (valueBlackoutForm: FormikValues): FormikValues => {
  const { from_time: fromTimeBlackout, to_time: toTimeBlackout } = valueBlackoutForm;

  const timeFormat = 'hh:mm a';

  const newFormat = 'HH:mm';

  const fromTimeParsed = parse(fromTimeBlackout, timeFormat, new Date());

  const fromTime24h = format(fromTimeParsed, newFormat);

  const toTimeParsed = parse(toTimeBlackout, timeFormat, new Date());

  const minutesToTime = getMinutes(toTimeParsed);

  const toTime24h = minutesToTime === fiftyNineMinutes
    ? format(toTimeParsed, newFormat)
    : format(subMinutes(toTimeParsed, 1), newFormat);

  return {
    ...valueBlackoutForm,
    from_time: fromTime24h,
    to_time: toTime24h,
  };
};
